import { FaEdit, FaTrash } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { API_CONFIG, API_HEADERS } from "../../network/config/ApiConfig";
import { USER_API_PATH } from "../../network/config/apiPaths";
import { updateMessage } from "../../redux/slice/toastSlice";
import { useDispatch } from "react-redux";
import { consoleLog } from "../../utils/log-utils";
// import { axiosApi } from "../../../network/service/config/AaxiosUtil";
import { useState } from "react";
import { isAdmin, isFranchisLogin } from "../../utils/userRoles";

function AlbumRoomsItem(props) {
  const navigate=useNavigate();
  const dispatch=useDispatch();
  const [product, setItem] = useState(props.item);
  const [itemStatus, setitemStatus] = useState(product.status);
  const reviews=()=>{
     navigate("/reviews",{state:{name:product.name}})
  }
  // const onStatusChange = async () => {
  //   let status = "YES";
  //   if (props.status == "NO") {
  //     status = "YES";
  //   } else {
  //     status = "NO";
  //   }

  //   let requestBody = {
  //     status: status,
  //     id: product.id,
  //   };

  //   await axiosApi
  //     .post(API_CONFIG.API_HOST + USER_API_PATH.UPDATE_USER, requestBody, {
  //       API_HEADERS,
  //     })
  //     .then((response) => {
  //       consoleLog("USER UPODATE", response);
  //       if (response.status === 200 && response.data.status === true) {
  //         setItem(product, (product.status = status));
  //         setitemStatus(status);
  //       } else {
  //         dispatch(
  //           updateMessage({
  //             display: true,
  //             message: "Error While updating info",
  //           })
  //         );
  //       }
  //     });

  //   // await dispatch(createUpdateAction(requestBody)).then((response) => {
  //   //   if (response.status == true) {
  //   //     setItem(product, (product.status = status));
  //   //     setitemStatus(status);
  //   //   } else {
  //   //     dispatch(
  //   //       updateMessage({
  //   //         display: true,
  //   //         message: "Error While updating info",
  //   //       })
  //   //     );
  //   //   }
  //   // });
  // };
 const addAlbumParticipents=()=>{
  navigate("/addAlbumParticipents")
 }
  return (
    <>
      <tr>
        <td> {props.sno} </td>
        <td onClick={reviews}>
          <Link className="anchor-color-change">{product.name}</Link>
        </td>
        
          <td> {product.link} </td>
          <td>{product.time}</td>
        
       
        {/* <td> {props.city} </td> */}
        <td>{product.patners} {product.patners.length>0?<br/>:""}<button className="btn btn-success" onClick={addAlbumParticipents}>Add</button></td>
        
       

        <td className="align-middle">
          <div class="form-check form-switch col-lg-12 d-flex justify-content-center">

            <input
              class="form-check-input"
              type="checkbox"
              role="switch"
              checked={product.status === "YES" ? true : false}

            />

          </div>
        </td>
      </tr>
    </>
  );
}

export default AlbumRoomsItem;
